import config from '../utils/EnvironmentSwitcher';
import AuctionsService from './marketplace/AuctionsService';
import BidsService from './marketplace/BidsService';
import ListingsService from './marketplace/ListingsService';
import NotificationsService from './marketplace/NotificationsService';

/**
 * Compatibility facade for legacy imports.
 * New code should prefer domain services from `src/services/marketplace`.
 */
export default class MarketplaceService {
  constructor() {
    const baseUrl = config.apiUrl;
    this.listings = new ListingsService(baseUrl);
    this.auctions = new AuctionsService(baseUrl);
    this.bids = new BidsService(baseUrl);
    this.notifications = new NotificationsService(baseUrl);
  }

  // Shared helper (kept for backward compatibility)
  async getAuthHeaders() {
    return this.listings.getAuthHeaders();
  }

  // Listings
  async getLatestIPFSMappings() { return this.listings.getLatestIPFSMappings(); }
  async getListings(options) { return this.listings.getListings(options); }
  async buyNFT(listingId) { return this.listings.buyNFT(listingId); }
  async cancelListing(listingId) { return this.listings.cancelListing(listingId); }
  async updateListingPrice(listingId, newPrice) { return this.listings.updateListingPrice(listingId, newPrice); }
  async getListingHistory(listingId) { return this.listings.getListingHistory(listingId); }
  async getUserListings() { return this.listings.getUserListings(); }
  formatListingData(formData) { return this.listings.formatListingData(formData); }
  async listNFTForSale(nftId, price) { return this.listings.listNFTForSale(nftId, price); }
  async getNFTById(nftId) { return this.listings.getNFTById(nftId); }
  async getListingById(listingId) { return this.listings.getListingById(listingId); }

  // Notifications
  async getUserNotifications() { return this.notifications.getUserNotifications(); }
}

